import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Auth0Provider } from '@auth0/auth0-react'
import { App } from './App'
import { providerFrom, auth0SettingsFrom, auth0Options } from './auth/provider'
import './styles.css'

/*
 * How this build signs people in, decided once, here (STE-1012). Through
 * Auth0 the SDK wraps the app; otherwise nothing changes.
 */
const provider = providerFrom(import.meta.env)
const settings = provider === 'auth0' ? auth0SettingsFrom(import.meta.env) : null

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      {provider !== 'auth0' ? (
        <App />
      ) : settings ? (
        <Auth0Provider {...auth0Options(settings, window.location.origin)}>
          <App auth0 />
        </Auth0Provider>
      ) : (
        // An Auth0 build with a value missing has nothing to sign in with, and says so.
        <main className="login"><div className="login__card"><h1>Sign-in is not set up</h1>
          <p className="lede">This environment is set to sign in through Auth0, but its settings are missing.</p></div></main>
      )}
    </BrowserRouter>
  </StrictMode>,
)
